<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <nav class="navbar navbar-expand-lg" style="background-color: white;">
    <div class="container-fluid navbar-margin">
      <router-link to="/" class="navbar-brand" href="#"><strong><span class="brand-color2">IC</span><span
            class="brand-color1"> Safety </span><span class="brand-color2">Solutions</span></strong></router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto align-items-center">

          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/services" class="nav-link">Services</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/articles" class="nav-link">Articles</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/contact" class="nav-link">Contact</router-link>
          </li>


        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {}
</script>
<style>
@property --brand-color-main {}

nav {
  position: sticky !important;
  top: 0;
  z-index: 1000;
}
.navbar-margin{
  margin: 0% 5%;
}
.nav-item {
  margin-left: 10px;
  font-weight: 500;
}

.navbar-brand {
  font-family: ui-sans-serif, system-ui, sans-serif;
  font-size: x-large;
}

/* todo make brand colors a variable */
.brand-color1 {
  color: rgb(245, 122, 34);
}

.brand-color2 {
  color: #0e5295;
}

@media (min-width:640px){
  .navbar-margin{
  margin: 0% 13%;
}
}
</style>
